import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, HostListener, Inject, NgZone, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AlertPopup, path, config } from 'app/app.config';
import { ConfirmationDialogService } from 'app/confirmation-dialog/confirmation-dialog.service';
import { HeaderService } from '../header/header.service';

import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { AssistBotService } from './assist-bot.service';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DialogService } from 'app/services/dialog.service';
import { SecureFileService } from 'app/secure-image/secure-image-service';
import { saveAs as importedSaveAs } from "file-saver";
import { DomSanitizer } from '@angular/platform-browser';
import { LlmService } from 'app/services/llm.service';
import { StaffRoomService } from '../staff-room/staff-room.service';
import { AppComponent } from 'app/app.component';
import { ValidationService } from '../form-validation/validation.service';
import { FileValidationService } from 'app/shared/file-validation.service';
import { ELibraryService } from '../elibraryandcourse/e-library/e-library.service';
import { ChatService } from '../chat-list/chat.service';
import { GuidedTourService, Orientation } from 'ngx-guided-tour';
import { IndexedDBService } from 'app/services/indexed-db.service';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';






declare const $: any;
declare const annyang: any;

// @Directive()
@Component({
  selector: 'app-ai-assist',
  templateUrl: './ai-assist.component.html',
  styleUrls: ['./ai-assist.component.scss'],

})
export class AiAssistComponent implements OnInit {
  //  @HostBinding('class.flex-grid') leftBarClass = true;
  //  @HostBinding('style.width') flexwidth = '100%';

  chatbotData: any = [];
  answerList: any = [];
  chatHistoryList: any = [];
  chatfileList: any = [];
  chatfileAudioList: any = [];
  showSearchSec: boolean = false;
  sortBy: string = "time";
  volumeicons: any = ["fa fa-volume-off", "fa fa-volume-up"];
  microphoneicons: any = ["fa fa-microphone-slash", "fa fa-microphone"];
  contentWidth: number = 0;
  hideLeftContent: boolean = true;
  hiderightPanel: boolean = false;
  search: any = "";
  userDetail: any;
  chatPinList: any = [];
  profileUrl = path.PROFILE_URL;
  suggestionList: any = [];
  searchSuggestion: any;
  autoSearchDafaultValue: string = "";
  selectedTags: string[] = [];
  questionArray: string[] = [];
  microphoneActive: boolean = false;
  showSearchesdropdown: boolean = false;
  voiceRecognitionInitialized: boolean = false;
  hidechatContent: boolean = false;

  accessType: 'private' | 'generic' = 'private';
  activeTab: 'history' | 'pin' | 'document' | 'audio' | 'live-speak-assist' | '';

  width: number = window.innerWidth;
  height: number = window.innerHeight;
  mobileWidth: number = 768;

  isSidebarOpen = false;


  resizeObservable$: Observable<Event>
  resizeSubscription$: Subscription;
  language: string = "eng";
  isShowLanguages: boolean = false;
  dropdownVisible: boolean = false;
  isBelowIpadSize: boolean = window.innerWidth < 768 ? true : false; // Check if screen size is below iPad size initially
  botTemplateName: string = "bot";
  botview: boolean;
  showDisclaimer: boolean = true;
  suggestionEnable: boolean = false;

  Bot_template_list: any = [];
  showAudioIndex: any;
  showTabConent: boolean = false;
  hidebotpanel: boolean = false;
  enableTabpanel: string = "";
  audioSafeUrl: any;
  toggle_text: any;
  selectedClassList: any;
  ClassListData: any[] = [];
  CategoryList: any[] = [];
  selectedClass: any;
  userRole: any;
  selectedDoc_ids: any[] = [];
  selectedDoc_name_map: any = {};
  selectedDoc_summary_category_map: any = {};
  /** Chat File Size limit */
  chatFileSizeLimit: number = config.MAX_ATTACH_FILE_SIZE;
  chatFileExt = config.TOPIC_EXT;
  @HostListener('window:resize', ['$event'])
  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isBelowIpadSize = window.innerWidth <= 768; // Update screen size on resize
    this.contentWidth = event.target.innerWidth;
    if (this.isBelowIpadSize) {
      this.hideLeftContent = true;
      this.hiderightPanel = true;
      // this.document.getElementById("chat-content-wrapper").style.display="flex";
      // this.document.getElementById("right-side-panel").style.width="100%";
    } else {
      // this.hideLeftContent = false;
      this.hiderightPanel = false;
      // this.document.getElementById("right-side-panel").style.width="20%";
      // this.document.getElementById("chat-content-wrapper").style.display="flex";
    }

    if (this.isBelowIpadSize) {
      this.showDisclaimer = false;
    } else {

      this.showDisclaimer = true;
    }
    // this.showDisclaimer = true;
    // const chatheader = this.document.getElementsByClassName('chat-header')[0].clientWidth;
    // this.document.getElementById('chat-list-content').style.width=chatheader+'px';
  }


  voiceActiveSectionDisabled: boolean = true;
  voiceActiveSectionError: boolean = false;
  voiceActiveSectionSuccess: boolean = false;
  voiceActiveSectionListening: boolean = false;
  voiceText: any;
  activeModal: boolean = false;
  selectedReadFile: any;
  showPaginateSpinner: boolean = false;
  documentViewerType: 'google' | 'office' = 'google'; // Viewer type for documents
  documentViewerUrl: string = ''; // Processed URL for viewer
  safeOfficeViewerUrl: any; // Sanitized URL for Office Online viewer

  modalScrollDistance = config.DEFAULT_SCROLL_DIST;
  modalScrollThrottle = config.SCROLL_THROTTLE;

  @ViewChild('scrollcontent') scrollcontent: ElementRef;
  @ViewChild('toggleButton') toggleButton: ElementRef;
  @ViewChild('elibraryFileInput') elibraryFileInput: ElementRef;
  @ViewChild('autocomplete') autocompleteComponent: AutocompleteComponent;
  viewControl = {
    hideDocumentView: false
  };

  currentIndex: any = 0;
  nextDisabled: boolean = false;
  prevDisabled: boolean = true;
  showFileLoadSpinner: boolean = false;
  elibraryList: any = [];
  popupTitle: string;
  HistoryOffset: number = 0;
  HistoryLimit: number = 20;
  PinOffset: number = 0;
  PinLimit: number = 20;
  AudioOffset: number = 0;
  AudioLimit: number = 20;
  DocOffset: number = 0;
  DocLimit: number = 20;
  activeFileUpload: boolean = false;
  upLoadedFileList: any = [];
  isDragging: boolean = false;
  uploadFileIcons = [
    { name: "pdf", icons: '../../../../assets/images/file_types/pdf.png' },
    { name: "doc", icons: '../../../../assets/images/file_types/doc.png' },
    { name: "docx", icons: '../../../../assets/images/file_types/docx.png' },
    { name: "txt", icons: '../../../../assets/images/file_types/txt.png' },
    { name: "odt", icons: '../../../../assets/images/file_types/odt.png' }
  ];
  uploadFileForm: FormGroup = new FormGroup({});
  fileLLMformData: any;
  summarization: any;
  llmfile_uuid: any;
  message_id: any = "";
  groupUserList: any;
  group_id: any;
  showBtnSpinner: boolean = false;
  document_title: any;
  constructor(private confirmDialogService: ConfirmationDialogService, private alert: AlertPopup, private fb: FormBuilder, private sanitizer: DomSanitizer, private appComponent: AppComponent, private elibraryService: ELibraryService,
    private headerService: HeaderService, private ngZone: NgZone, @Inject(DOCUMENT) private document: Document, private http: HttpClient, private assistBotService: AssistBotService, private chatService: ChatService,
    private renderer: Renderer2, private route: ActivatedRoute, private fileValidationService: FileValidationService, private router: Router, private dialogService: DialogService, private securefileservice: SecureFileService, private llmService: LlmService, private staffRoomService: StaffRoomService, private guidedTourService: GuidedTourService, private indexedDBService: IndexedDBService) {
    //     this.renderer.listen('window', 'click',(e:Event)=>{
    //       /**
    //        * Only run when toggleButton is not clicked
    //        * If we don't check this, all clicks (even on the toggle button) gets into this
    //        * section which in the result we might never see the menu open!
    //        * And the menu itself is checked here, and it's where we check just outside of
    //        * the menu and button the condition abbove must close the menu
    //        */
    //      if(e.target !== this.toggleButton.nativeElement){
    //          this.hideLeftContent=true;
    //      }
    //  });

  }

  ngOnInit(): void {
    // this.selectedReadFile="https://www.princexml.com/howcome/2016/samples/invoice/index.pdf";

    let document_id = this.route.snapshot.paramMap.get('id');
    this.document_title = this.route.snapshot.paramMap.get('title');
    console.log("doc id", document_id);

    this.assistBotService.queryType['library'] = true;
    this.assistBotService.chatHistoryList = [];
    this.assistBotService.chatPinList = [];
    this.assistBotService.seletedClass = [];
    // if (this.assistBotService.queryType['library']) {
    //   this.toggle_text = "Enabled in private data fetch from uploaded documents";
    // } else {
    //   this.toggle_text = "Enabled in Genric data fetch from global";
    // }
    if (this.assistBotService.queryType['library']) {
      //this.toggle_text = "ask question from documents";
      this.toggle_text = "Ask anything....";
    } else {
      this.toggle_text = "How may i assist you";
    }
    
    // this.assistBotService.getClientConfig().subscribe((res: any) => {
    //   this.assistBotService.GptConfiguration = res.filter((configlist: any) => configlist['clientModule'] == client)[0]['configuration'];
    //   this.Bot_template_list = this.assistBotService.GptConfiguration['Bot_template'];
    // });
    this.chatbotData = [];
    this.botTemplateName = "bot";
    this.botview = this.botTemplateName == 'bot' ? true : false;
    this.getllmUserInfo();
    this.getBotHistory();

    // Assign values from llmService
    this.selectedDoc_ids = this.llmService.selectedDoc_ids || [];
    this.selectedDoc_name_map = this.llmService.selectedDoc_name_map || {};
    this.selectedDoc_summary_category_map = this.llmService.selectedDoc_summary_category_map || {};


    // Populate CategoryList from selectedDoc_summary_category_map
    this.populateCategoryList();

    // Update llm_bot_payload with selected documents
    this.updateLLMBotPayload();
    // this.getAnswerList().subscribe((result: any) => {
    //   this.answerList = result.filter((res: any) => res['bot_type'] == "suggestion");

    // });
    this.headerService.getCurrentUserDetail().subscribe((result: any) => {
      if (result['success']) {
        this.userDetail = result['userDetail'];
      }

    });
    this.document.body.classList.add('scroll-stop');

    this.route.url.subscribe(() => {
      this.isBelowIpadSize = window.innerWidth < 768;
      if (this.isBelowIpadSize) {
        this.hiderightPanel = true;
        this.hideLeftContent = true;
      }
    });

    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.subscribe((evt: any) => {
      let windowWidth = evt.target.innerWidth;
      if (windowWidth <= this.mobileWidth) {
        this.hidechatContent = false;

      } else {
        this.hidechatContent = true;

      }

    });
    // this.changeTemplate(this.botTemplateName);


    /* this.assistBotService.historyListBheaviour.subscribe((data: any) => {
       this.getBotHistory();
       this.chatHistoryList = [];
       this.chatfileList = [];
       this.chatfileAudioList = [];
       if (data["templateName"] == "bot") {
         this.chatHistoryList = this.assistBotService.chatHistoryList.filter((hList: any) => hList.question_type == "history" && hList.bot_type == "bot");
         this.chatPinList = this.assistBotService.chatPinList.filter((hList: any) => hList.question_type == "pin" && hList.bot_type == "bot");
         this.chatbotData = this.chatHistoryList;
        this.chatfileList = [];
        this.chatfileAudioList = [];
        this.chatfileList = this.assistBotService.chatHistoryList.filter((hList: any) => (hList.question_type == "pdf" || hList.question_type == "word") && hList.bot_type == "bot");
         this.chatfileAudioList = this.assistBotService.chatHistoryList.filter((hList: any) => hList.question_type == "audio" && hList.bot_type == "bot");

       } else if (data["templateName"] == "normal") {
         this.chatHistoryList = this.assistBotService.chatHistoryList.filter((hList: any) => hList.question_type == "history" && hList.bot_type == "normal");
         this.chatPinList = this.assistBotService.chatPinList.filter((hList: any) => hList.question_type == "pin" && hList.bot_type == "normal");
        this.chatfileList = [];
        this.chatfileAudioList = [];
        this.chatfileList = this.assistBotService.chatHistoryList.filter((hList: any) => (hList.question_type == "pdf" || hList.question_type == "word") && hList.bot_type == "normal");
        this.chatfileAudioList = this.assistBotService.chatHistoryList.filter((hList: any) => hList.question_type == "audio" && hList.bot_type == "normal");
         this.chatbotData=this.chatHistoryList;

       } else if (data["templateName"] == "suggestion") {

         this.chatHistoryList = this.assistBotService.chatHistoryList.filter((hList: any) => hList.question_type == "history" && hList.bot_type == "suggestion");
         this.chatPinList = this.assistBotService.chatPinList.filter((hList: any) => hList.question_type == "pin" && hList.bot_type == "suggestion");
         this.chatbotData = this.chatHistoryList;
         this.chatfileList = [];
         this.chatfileAudioList = [];
         this.chatfileList = this.assistBotService.chatHistoryList.filter((hList: any) => (hList.question_type == "pdf" || hList.question_type == "word") && hList.bot_type == "suggestion");
         this.chatfileAudioList = this.assistBotService.chatHistoryList.filter((hList: any) => hList.question_type == "audio" && hList.bot_type == "suggestion");

       } else if (data["templateName"] == "careinsurance") {
         this.chatHistoryList = this.assistBotService.chatHistoryList.filter((hList: any) => hList.question_type == "history" && hList.bot_type == "careinsurance");
         this.chatPinList = this.assistBotService.chatPinList.filter((hList: any) => hList.question_type == "pin" && hList.bot_type == "careinsurance");
         this.chatbotData = this.chatHistoryList;
         this.chatfileList = [];
         this.chatfileAudioList = [];
         this.chatfileList = this.assistBotService.chatHistoryList.filter((hList: any) => (hList.question_type == "pdf" || hList.question_type == "word") && hList.bot_type == "careinsurance");
         this.chatfileAudioList = this.assistBotService.chatHistoryList.filter((hList: any) => hList.question_type == "audio" && hList.bot_type == "careinsurance");
       }

     }); */


    this.hiderightPanel = true;



    this.uploadFileForm = this.fb.group({
      // Simplified form - only file upload needed
    });






    this.indexedDBService.getAllData().then(res => {
      console.log(res);
    });




  }

  changeAccessType(type: any) {
    this.accessType = type;

    this.assistBotService.queryType['library'] = type;
  }

  toggleAISidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  //   SelectedLang(event: any) {
  //     this.language = event.target.value;
  //     this.getAnswerList().subscribe((result: any) => {
  //       this.answerList = result.filter((res: any) => res['lang'] == this.language);
  //     });
  //     this.getAnswerList().subscribe((result: any) => {
  //       this.suggestionList = result.filter((res: any) => res['lang'] == this.language);
  //     });
  //  }

  changeTemplate(value: string) {
    this.hideLeftContent = !this.hideLeftContent;
    this.botTemplateName = value;
    this.botview = this.botTemplateName === `${value}` ? true : false;
    this.assistBotService.historyListBheaviour.next({ "templateName": value });
    this.suggestionEnable = false;
    if (this.botTemplateName == "suggestion") {
      this.suggestionEnable = true;
      // this.getAnswerList().subscribe((result: any) => {
      //   this.suggestionList = result.filter((res: any) => res['bot_type'] == 'suggestion');
      // });
    } else {
      this.suggestionList = [];
    }

    if (this.isBelowIpadSize) {
      this.hidePanel('rightpanel');
    }

  }

  hidePanel(panel: string) {
    // this.router.navigateByUrl("/aiassist/choosetemplate");
    this.assistBotService.tabPanelBheaviour.next({ 'actionShow': false });
    let windowWith = window.innerWidth;
    if (windowWith <= this.mobileWidth) {
      if (panel == 'hidebotpanel') {
        this.hidebotpanel = true;
        this.hideLeftContent = false;
      } else {
        this.hidebotpanel = false;
        this.hideLeftContent = true;
      }
    }



    // setTimeout(() => {
    //   const chatheader = this.document.getElementsByClassName('chat-header')[0].clientWidth;
    //   this.document.getElementById('chat-list-content').style.width=chatheader+'px';
    // },50);
  }
  speakText(state: boolean, textdata: string) {

    let text = textdata.replace(/(<([^>]+)>)/gi, "");
    if ('speechSynthesis' in window) {
      var to_speak = new SpeechSynthesisUtterance(text);
      if (state) {
        speechSynthesis.cancel();
        window.speechSynthesis.speak(to_speak);
      } else {
        speechSynthesis.cancel();
      }

    } else {
      console.log('not support ');
    }
  }



  copyText(index) {
    let textdata = this.chatbotData[index]['bot_answer'];
    let text = textdata.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g, " ").replace(/[\/\\#+()$~*<>{}]/gi, '');
    if (!navigator.clipboard) {
      // use old commandExec() way
    } else {
      this.alert.showAlertMessage({ "message": "Copy this text to clipboard.." });
      navigator.clipboard.writeText(text).then(
        function () {
          console.log("yeah!"); // success


        })
        .catch(
          function () {
            console.log("err"); // error
          });
    }
  }


  resizeIframe(obj) {

    obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
  }


  sortingBy(event: any) {
    if (event == "asc") {
      this.chatHistoryList.sort((a: any, b: any) => a['question'] < b['question'] ? 1 : -1);
    } else {
      this.chatHistoryList.sort((a: any, b: any) => a > b ? 1 : -1);
    }

  }

  setautoComplete(value: any) {
    this.autoSearchDafaultValue = value['data'];
    if (value['tags'] !== undefined) {
      this.selectedTags = value['tags'];
    }
    if (value['questionArray'] !== undefined && Array.isArray(value['questionArray'])) {
      this.questionArray = value['questionArray'];
      console.log('questionArray received in setautoComplete:', this.questionArray);
    }
    // if (value['action'] != "Keypress") {
    //   this.save();
    // }
  }
  save() {

    // if(this.assistBotService.queryType['library'] && this.assistBotService.seletedClass.length==0){
    //   this.alert.showAlertMessage({ "message": "Please select the document from dropdown" });
    //   return;
    // }

    // Sync values from llmService before saving
    this.updateFromService();
    this.updateLLMBotPayload();

    let questionIndex = 0;
    this.microphoneActive = false;
    this.scrollTop();

    // Check if there's any input (either tags or voice text)
    const hasTags = this.selectedTags.length > 0;
    const hasVoiceText = this.autoSearchDafaultValue && this.autoSearchDafaultValue.trim().length > 0;

    if (!hasTags && !hasVoiceText) {
      this.alert.showAlertMessage({ "message": "Please enter your question" });
      return;
    }

    if (this.botTemplateName == "bot") {
      const questionText = this.selectedTags.length > 0 ? this.selectedTags.join(', ') : this.autoSearchDafaultValue.trim();
      console.log('questionArray in save() before creating answerData:', this.questionArray);
      console.log('selectedTags in save():', this.selectedTags);
      console.log('autoSearchDafaultValue in save():', this.autoSearchDafaultValue);

      // questionArray should be the array of all selectedTags (each tag is a full sentence, not split)
      // Use questionArray from event if available, otherwise use selectedTags directly
      let finalQuestionArray = this.questionArray;
      if (!Array.isArray(this.questionArray) || this.questionArray.length === 0) {
        // If questionArray is not set, use selectedTags directly (each tag is one item in array)
        finalQuestionArray = this.selectedTags.length > 0 ? [...this.selectedTags] :
          (this.autoSearchDafaultValue ? [this.autoSearchDafaultValue.trim()] : []);
        console.log('Created questionArray from selectedTags (no splitting):', finalQuestionArray);
      }

      let answerData = [{
        "questionId": '',
        "bot_type": "bot",
        "question": questionText,
        "answer": "",
        "search": true,
        "questionArray": Array.isArray(finalQuestionArray) && finalQuestionArray.length > 0 ? finalQuestionArray : undefined
      }];
      console.log('answerData with questionArray:', answerData[0]);
      console.log('answerData.questionArray type:', typeof answerData[0].questionArray);
      console.log('answerData.questionArray is array?', Array.isArray(answerData[0].questionArray));
      this.chatbotData.unshift(answerData[0]);
      // setTimeout(()=>{
      this.autoSearchDafaultValue = "";
      this.selectedTags = [];
      this.questionArray = [];
      // },2000);

    } else if (this.botTemplateName == "suggestion") {
      const questionText = this.selectedTags.length > 0 ? this.selectedTags.join(', ') : this.autoSearchDafaultValue.trim();
      let answer = this.answerList.filter((data: any) => data['question'].toLowerCase() == questionText.toLowerCase())
      let answerData = [{
        "questionId": '',
        "bot_type": "suggestion",
        "question": questionText,
        "bot_answer": answer[0]['bot_answer'],
        "sequence_id": answer[0]['sequence_id'],
        "search": true
      }];
      this.chatbotData.unshift(answerData[0]);
      //setTimeout(()=>{
      this.autoSearchDafaultValue = "";
      this.selectedTags = [];
      this.questionArray = [];
      /////},2000);
    } else if (this.botTemplateName == "careinsurance") {
      const questionText = this.selectedTags.length > 0 ? this.selectedTags.join(', ') : this.autoSearchDafaultValue.trim();
      let answerData = [{
        "questionId": '',
        "bot_type": "careinsurance",
        "question": questionText,
        "answer": "",
        "search": true,
        "questionArray": this.questionArray.length > 0 ? this.questionArray : undefined
      }];
      this.chatbotData.unshift(answerData[0]);
      // setTimeout(()=>{
      this.autoSearchDafaultValue = "";
      this.selectedTags = [];
      this.questionArray = [];
      //},2000);
    }

    // Clear the autocomplete component's tags after save
    if (this.autocompleteComponent) {
      this.autocompleteComponent.clear();
    }

  }





  showSearchbox() {
    this.showSearchSec = !this.showSearchSec;
    this.search = "";
  }

  onKeypressEvent(event: any, userForm: any) {
    this.microphoneActive = true;
    if ((event.ctrlKey && event.code == "Enter") || (event.ctrlKey && event.code == "NumpadEnter")) {
      this.save();
    }
  }

  gotoHistory(index) {
    this.viewControl.hideDocumentView = false;
    this.hideLeftContent = !this.hideLeftContent;
    if (this.isBelowIpadSize) {
      this.hidePanel('leftpanel');
      this.showDisclaimer = true;
    }
    //  $("#chat-list").animate({
    //     scrollTop:Math.round($('#question'+index).parents('app-bot').offset().top) -  Math.round($("#chat-list").offset().top)
    //   },1000);

    //  setTimeout(() => {
    //if (this.activeTab == 'history') {
    var isScrolling;
    setTimeout(() => {
      const element = document.getElementById('question' + index);
      element.scrollIntoView({ behavior: 'smooth' });
      this.document.getElementById("chat-list-content").addEventListener("scroll", (ev: any) => {
        // Clear our timeout throughout the scroll
        window.clearTimeout(isScrolling);
        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(function () {
          document.getElementsByTagName("body")[0].scrollTop = 0;
          // Run the callback

        }, 100);
      });
    }, 10);
    this.activeTab = "";
    // this.document.getElementById("chat-list-content").addEventListener("scroll", (ev: any) => {
    //   // Clear our timeout throughout the scroll
    //   window.clearTimeout(isScrolling);
    //   // Set a timeout to run after scrolling ends
    //   isScrolling = setTimeout(function () {
    //     document.getElementsByTagName("body")[0].scrollTop = 0;
    //     // Run the callback

    //   }, 100);
    // });
    //}


    //  },1000);
    // setTimeout(() => {
    //  document.getElementsByTagName('body')[0].scrollTop=0;
    // },1500);
  }


  removeHistory(history_id) {
    this.confirmDialogService.openConfirmDialog('',
      {
        title: 'Confirmation',
        message: 'Do you want to delete the history?',
        btnOkText: 'YES',
        btnCancelText: 'NO',
        onClose: (data: any) => {
          if (data) {
            this.assistBotService.deleteHistory(history_id).subscribe((result: any) => {
              if (result['success']) {
                this.alert.showAlertMessage({ "message": "History was deleted Successfully." });
              }
            });

            let chatbotDataIndex = this.chatbotData.findIndex((d: any) => d['history_id'] == history_id && d.bot_type == this.botTemplateName);
            let chatHistoryDataIndex = this.assistBotService.chatHistoryList.findIndex((d: any) => d['history_id'] == history_id && d.bot_type == this.botTemplateName);

            if (chatbotDataIndex != -1) {
              this.chatbotData.splice(chatbotDataIndex, 1);
              this.chatHistoryList.splice(chatbotDataIndex, 1);
            }

            if (chatHistoryDataIndex != -1) {
              this.assistBotService.chatHistoryList.splice(chatHistoryDataIndex, 1);
              this.assistBotService.historyListBheaviour.next({ "templateName": this.botTemplateName });
            }
          }
        }
      });
  }


  removePin(history_id) {
    this.confirmDialogService.openConfirmDialog('',
      {
        title: 'Confirmation',
        message: 'Do you want to delete pin?',
        btnOkText: 'YES',
        btnCancelText: 'NO',
        onClose: (data: any) => {
          if (data) {
            this.assistBotService.deletePin(history_id).subscribe((result: any) => {
              if (result['success']) {
                this.alert.showAlertMessage({ "message": "Your requested data pin was deleted successfully." });
              }
            });

            let chatbotDataIndex = this.chatPinList.findIndex((d: any) => d['history_id'] == history_id && d.bot_type == this.botTemplateName);


            if (chatbotDataIndex != -1) {
              this.chatPinList.splice(chatbotDataIndex, 1);
              this.assistBotService.chatPinList.splice(chatbotDataIndex, 1);
              if (this.currentIndex == 0) {
                if (this.chatPinList.length > 0) {
                  this.viewFile(0);
                } else {
                  this.popupTitle = '';
                }
              } else {
                this.viewFile(chatbotDataIndex - 1);
              }
              // this.assistBotService.historyListBheaviour.next({ "templateName": this.botTemplateName });
            }
          }
        }
      });
  }

  removeDocument(history_id) {
    this.confirmDialogService.openConfirmDialog('',
      {
        title: 'Confirmation',
        message: 'Do you want to delete document?',
        btnOkText: 'YES',
        btnCancelText: 'NO',
        onClose: (data: any) => {
          if (data) {
            this.assistBotService.deleteDoc(history_id).subscribe((result: any) => {
              if (result['success']) {
                this.alert.showAlertMessage({ "message": "Your requested document was deleted successfully." });
              }
            });

            let chatbotDataIndex = this.chatfileList.findIndex((d: any) => d['history_id'] == history_id);


            if (chatbotDataIndex != -1) {
              this.chatfileList.splice(chatbotDataIndex, 1);
              if (this.currentIndex == 0) {
                if (this.chatfileList.length > 0) {
                  this.viewFile(0);
                } else {
                  this.popupTitle = '';
                }
              } else {
                this.viewFile(chatbotDataIndex - 1);
              }
              //this.assistBotService.chatPinList.splice(chatbotDataIndex, 1);
              //this.assistBotService.historyListBheaviour.next({ "templateName": this.botTemplateName });
            }
          }
        }
      });
  }

  removeAudio(history_id) {
    this.confirmDialogService.openConfirmDialog('',
      {
        title: 'Confirmation',
        message: 'Do you want to delete audio?',
        btnOkText: 'YES',
        btnCancelText: 'NO',
        onClose: (data: any) => {
          if (data) {
            this.assistBotService.deleteAudio(history_id).subscribe((result: any) => {
              if (result['success']) {
                this.alert.showAlertMessage({ "message": "Your requested audio was deleted successfully." });
              }
            });

            let chatbotDataIndex = this.chatfileAudioList.findIndex((d: any) => d['history_id'] == history_id);


            if (chatbotDataIndex != -1) {
              this.chatfileAudioList.splice(chatbotDataIndex, 1);
              if (this.currentIndex == 0) {
                if (this.chatfileAudioList.length > 0) {
                  this.viewFile(0);
                } else {
                  this.popupTitle = '';
                }
              } else {
                this.viewFile(chatbotDataIndex - 1);
              }
              //this.assistBotService.chatPinList.splice(chatbotDataIndex, 1);
              //this.assistBotService.historyListBheaviour.next({ "templateName": this.botTemplateName });
            }
          }
        }
      });
  }

  filterChat(data) {
    if (this.search) {
      return data.filter((elem: any) => {
        return elem['question'].toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });
    } else {
      return data;
    }

  }

  filterSuggestion(val) {

    if (val.target.value != "") {
      this.searchSuggestion = val.target.value;
      this.suggestionList = this.suggestionList.filter((elem: any) => {
        return elem.toLowerCase().indexOf(val.target.value.toLowerCase()) > -1;
      });
    } else {
      // this.getAnswerList().subscribe((result: any) => {
      //   this.suggestionList = result.map((que: any) => que['question']);
      // });
    }
  }

  autosuggestion(event: any) {
    this.suggestionEnable = event.currentTarget.checked;
    if (event.currentTarget.checked) {
      // this.getAnswerList().subscribe((result: any) => {
      //      this.suggestionList= result.filter((res:any)=>res['bot_type']=='suggestion');
      // });
    } else {
      this.botTemplateName = "bot";
      this.suggestionList = [];
    }

  }


  // getAnswerList() {
  //   return this.http.get('../assets/json/ai-chat.json');
  // }


  initializeVoiceRecognitionCallback(): void {
    // Remove existing callbacks to avoid duplicates
    if (annyang.removeCallback) {
      annyang.removeCallback('error');
      annyang.removeCallback('soundstart');
      annyang.removeCallback('end');
      annyang.removeCallback('result');
    }

    annyang.addCallback('error', (err: any) => {
      this.ngZone.run(() => {
        if (err.error === "no-speech") {
          this.voiceActiveSectionError = true;
          this.microphoneActive = false;
          annyang.abort();
          this.closeVoiceRecognition();
        } else if (err.error === 'network') {
          this.voiceText = "Internet is required";
          this.voiceActiveSectionError = true;
          annyang.abort();
          this.closeVoiceRecognition();
        } else if (err.error === 'not-allowed' || err.error === 'permission-denied') {
          // this.voiceText = "Microphone permission denied";
          this.voiceActiveSectionError = true;
          this.alert.showAlertMessage({ "message": "Microphone permission is required for voice recognition." });
          annyang.abort();
          this.closeVoiceRecognition();
        } else {
          this.voiceActiveSectionError = true;
          if (this.voiceText === undefined) {
            annyang.abort();
            this.closeVoiceRecognition();
          }
        }
      });
    });

    annyang.addCallback('soundstart', (res: any) => {
      this.ngZone.run(() => {
        this.voiceActiveSectionListening = true;
        this.voiceActiveSectionError = false;
        // Auto-close after 10 seconds of listening
        setTimeout(() => {
          if (this.microphoneActive) {
            this.closeVoiceRecognition();
            this.microphoneActive = false;
          }
        }, 5000);
      });
    });

    annyang.addCallback('end', (res: any) => {
      this.ngZone.run(() => {
        if (this.voiceText === undefined || !this.voiceText) {
          this.voiceActiveSectionError = true;
          this.microphoneActive = false;
          annyang.abort();
          this.closeVoiceRecognition();
        } else {
          this.voiceActiveSectionError = false;
          this.microphoneActive = false;
          this.voiceActiveSectionDisabled = true;
          this.autoSearchDafaultValue = this.voiceText;
          console.log('Voice text captured:', this.autoSearchDafaultValue);
          this.closeVoiceRecognition();
          annyang.abort();
          // Auto-save after a short delay
          setTimeout(() => {
            this.save();
          }, 300);
        }
      });
    });

    annyang.addCallback('result', (userSaid) => {
      this.ngZone.run(() => {
        if (userSaid && userSaid.length > 0) {
          let queryText: any = userSaid[0];
          this.voiceText = queryText;
          this.voiceActiveSectionError = false;
          this.voiceActiveSectionListening = false;
          this.voiceActiveSectionSuccess = true;


          if (annyang) {
            annyang.abort();
          }
        } else {
          this.voiceActiveSectionError = true;
          this.voiceActiveSectionListening = false;
        }
      });
    });
  }

  startVoiceRecognition(): void {
    // Check if annyang is available
    if (typeof annyang === 'undefined' || !annyang) {
      console.error('Annyang is not available. Make sure annyang.min.js is loaded.');
      this.alert.showAlertMessage({ "message": "Voice recognition is not available in your browser." });
      this.microphoneActive = false;
      return;
    }

    // Check if browser supports speech recognition
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (!SpeechRecognition) {
      console.error('Speech recognition is not supported in this browser.');
      this.alert.showAlertMessage({ "message": "Your browser does not support voice recognition." });
      this.microphoneActive = false;
      return;
    }

    this.autoSearchDafaultValue = "";
    this.voiceActiveSectionDisabled = false;
    this.voiceActiveSectionError = false;
    this.voiceActiveSectionSuccess = false;
    this.voiceText = undefined;
    this.microphoneActive = true;

    try {
      annyang.setLanguage('en');

      // Initialize callbacks only once
      if (!this.voiceRecognitionInitialized) {
        this.initializeVoiceRecognitionCallback();
        this.voiceRecognitionInitialized = true;
      }

      // Start voice recognition
      annyang.start({ autoRestart: false });

    } catch (error) {
      console.error('Error starting voice recognition:', error);
      this.alert.showAlertMessage({ "message": "Failed to start voice recognition. Please check your microphone permissions." });
      this.microphoneActive = false;
      this.closeVoiceRecognition();
    }
  }
  // toggleDropdown(){
  //   this.isShowLanguages=!this.isShowLanguages
  // }
  closeVoiceRecognition(): void {
    this.voiceActiveSectionDisabled = true;
    this.voiceActiveSectionError = false;
    this.voiceActiveSectionSuccess = false;
    this.voiceActiveSectionListening = false;
    this.microphoneActive = false;

    if (typeof annyang !== 'undefined' && annyang) {
      try {
        annyang.abort();
      } catch (error) {
        console.error('Error aborting annyang:', error);
      }
    }

    // Don't clear voiceText here as it might be used in save()
    // this.voiceText = undefined;
  }

  PingChat(index: number) {
    let pingfilter = this.chatPinList.filter(ping => ping['sequence_id'] == this.chatbotData[index]["sequence_id"]);
    if (pingfilter.length > 0) {
      this.alert.showAlertMessage({ "message": "Your requested data pin already exist.", "type": 2 });
      return;
    }


    let user_id = window.localStorage.getItem('user_id');
    let botPayload = {
      "user_id": user_id,
      "question": this.chatbotData[index]["question"] || '1000',
      "answer": this.chatbotData[index]['bot_answer'],
      "question_type": "pin",
      "sequence_id": this.chatbotData[index]["sequence_id"],
      "bot_type": this.botTemplateName
    }


    // if (this.botTemplateName == "suggestion") {
    //   this.alert.showAlertMessage({ "message": "Your requested data pin was created successfully." });
    //   this.assistBotService.chatPinList.unshift(botPayload);
    //    this.chatPinList.unshift(botPayload);
    //   this.assistBotService.historyListBheaviour.next({ "templateName": this.botTemplateName });
    // }

    this.assistBotService.createHistory(botPayload).subscribe((result: any) => {
      if (result['success']) {
        this.alert.showAlertMessage({ "message": "Your requested data pin was created successfully." });
        //this.assistBotService.chatPinList.unshift(botPayload);
        this.chatPinList.unshift(botPayload);
        this.assistBotService.historyListBheaviour.next({ "templateName": this.botTemplateName });
      }
    });
  }


  Like(index: number) {
    this.alert.showAlertMessage({ "message": "You are like QA" });
  }

  Dislike(index: number) {
    this.alert.showAlertMessage({ "message": "You are dislike QA" });
  }


  getBotHistoryList() {
    this.assistBotService.getBotHistory(0, 25).subscribe({
      next: (result: any) => {
        this.chatHistoryList = result['data'];
        //this.chatHistoryList = [...this.chatHistoryList,...result['data']];
        //this.assistBotService.chatHistoryList=this.chatHistoryList;
        this.showPaginateSpinner = false;
      }, error: (error: HttpErrorResponse) => {
        this.showPaginateSpinner = false;
      }
    });
  }

  getBotHistory() {
    this.showPaginateSpinner = true;

    this.assistBotService.getBotHistory(this.HistoryOffset, this.HistoryLimit).subscribe({
      next: (result: any) => {
        this.chatbotData = [...this.chatbotData, ...result['data']];
        //this.chatHistoryList = [...this.chatHistoryList,...result['data']];
        this.assistBotService.chatHistoryList = this.chatHistoryList;
        this.showPaginateSpinner = false;
      }, error: (error: HttpErrorResponse) => {
        this.showPaginateSpinner = false;
      }
    });
    /*this.assistBotService.getChatBotHistory().subscribe((result: any) => {
      if (result['success']) {
        this.showPaginateSpinner = false;
        let data = result['result'];
        console.log("bot hist res",result);
        this.assistBotService.chatHistoryList = data;
        if(data.length > 0){
           this.assistBotService.chatPinList = data.filter((list:any)=>list['question_type']=="pin");
        }

        this.assistBotService.historyListBheaviour.next({ "templateName": this.botTemplateName });
      }else{
         this.showPaginateSpinner = false;
        let data = result['result'];
        console.log("bot hist res",result);
        this.assistBotService.chatHistoryList = data;
      }
    },(error:HttpErrorResponse)=>{
        this.showPaginateSpinner = false;
    }); */
    //  this.assistBotService.getComments().subscribe((result:any)=>{
    //    console.log("result",result);
    //    if(result['success']){
    //       this.assistBotService.ChatCommentsList= result['result'];
    //    }

    // });


  }



  onScrollDown() {

  }

  downloadFile(data: any) {
    try {
      const url = data['download_url'];

      if (url) {
        this.securefileservice.secureFileDownLoad(url).subscribe(
          (blob) => {
            if (data?.document_file_name) {
              importedSaveAs(blob, data['document_file_name']);
            } else {
              importedSaveAs(blob, data['file_id']);
            }

          },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.alert.showAlertMessage({ "message": "File Not Found" })
          }
        );
      }
    } catch (error) {

      console.log(error);
    }

  }

  viewFile(index: any) {
    try {
      this.selectedReadFile = '';
      this.popupTitle = '';
      this.currentIndex = index;

      let url: any = null;
      const isDoc = this.activeTab === 'document';
      const isAudio = this.activeTab === 'audio';
      const isHistory = this.activeTab === 'history';
      const isPin = this.activeTab === 'pin';

      if (isDoc) {
        if (this.chatfileList[index]?.view_url) {
          this.showPaginateSpinner = true;
          this.popupTitle = this.chatfileList[index]['question'];
          url = this.chatfileList[index].view_url;
          if (this.chatfileList.length > 1) {
            this.nextDisabled = false;
          } else {
            this.nextDisabled = true;
          }

          if (this.chatfileList.length == (this.currentIndex + 1) && this.chatfileList.length > 1) {
            this.nextDisabled = true;
            this.prevDisabled = false;
          }
          if (index == 0) {
            this.prevDisabled = true;
          } else {
            this.prevDisabled = false;
          }
        }
        console.log("url", url);
        console.log("this.chatfileList", this.chatfileList);
        console.log("this.selectedReadFile", this.selectedReadFile);

      } else if (isAudio) {
        this.popupTitle = this.chatfileAudioList[index]['question'];
        if (this.chatfileAudioList[index]?.view_url) {

          url = this.chatfileAudioList[index].view_url;
          if (this.chatfileAudioList.length > 1) {
            this.nextDisabled = false;
          } else {
            this.nextDisabled = true;
          }
        }
        if (this.chatfileAudioList.length == (this.currentIndex + 1) && this.chatfileAudioList.length > 1) {
          this.nextDisabled = true;
          this.prevDisabled = false;
        }
        if (index == 0) {
          this.prevDisabled = true;
        }
      } else if (isHistory) {
        if (this.chatHistoryList[index]) {
          this.popupTitle = this.chatHistoryList[index]['question'];
          this.selectedReadFile = this.chatHistoryList[index];
          this.showPaginateSpinner = false;
          if (this.chatHistoryList.length > 1) {
            this.nextDisabled = false;
          } else {
            this.nextDisabled = true;
          }
        }
      } else if (isPin) {
        if (this.chatPinList.length == 0) {
          this.nextDisabled = true;
          this.prevDisabled = true;
        }
        if (this.chatPinList[index]) {
          this.popupTitle = this.chatPinList[index]['question'];
          this.selectedReadFile = this.chatPinList[index];
          this.showPaginateSpinner = false;
          if (this.chatPinList.length > 1) {
            this.nextDisabled = false;
          } else {
            this.nextDisabled = true;
          }
        }
        if (this.chatPinList.length == (this.currentIndex + 1) && this.chatPinList.length > 1) {
          this.nextDisabled = true;
          this.prevDisabled = false;
        }
        if (index == 0) {
          this.prevDisabled = true;
        }
      }

      if (url) {
        this.activeModal = true;
        this.showPaginateSpinner = true;
        this.showFileLoadSpinner = true;

        if (!isHistory && !isPin) {
          // Detect file type first
          const urlLower = url.toLowerCase();
          const isWordDoc = (urlLower.includes('.docx') || urlLower.includes('.doc')) && !urlLower.includes('.pdf');

          if (isWordDoc) {
            // For Word documents, try Microsoft Office Online viewer first
            // This requires the URL to be publicly accessible
            const encodedUrl = encodeURIComponent(url);
            this.documentViewerType = 'office';
            this.documentViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;
            // Sanitize the URL for use in iframe
            this.safeOfficeViewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentViewerUrl);
            this.selectedReadFile = this.documentViewerUrl;
            this.showPaginateSpinner = false;
            this.showFileLoadSpinner = false;
            this.activeModal = true;

            // If Office Online viewer doesn't work (due to CORS/authentication),
            // fallback: fetch file and create blob URL for download
            // Note: This is handled in the HTML template with a fallback message
          } else {
            // For PDFs, fetch the file and use Google Docs Viewer
            this.securefileservice.secureReadfile(url).subscribe(
              (blob) => {
                this.activeModal = true;
                this.documentViewerType = 'google';
                this.selectedReadFile = url;
                this.documentViewerUrl = url;
                this.showPaginateSpinner = false;
                this.showFileLoadSpinner = false;
              },
              (error: HttpErrorResponse) => {
                this.showPaginateSpinner = false;
                this.showFileLoadSpinner = false;
                this.alert.showAlertMessage({ message: 'File Not found' });
              }
            );
          }
        }
      } else if (!isHistory && !isPin) {
        this.showPaginateSpinner = false;
        //this.alert.showAlertMessage({ message: 'File Not Found' });
      }
    } catch (error) {
      this.showPaginateSpinner = false;
      this.showFileLoadSpinner = false;
      console.error('viewFile error:', error);
    }
  }

  closeModal() {
    this.activeModal = !this.activeModal;
    // Clean up blob URL if it was created
    if (this.selectedReadFile && this.selectedReadFile.startsWith('blob:')) {
      URL.revokeObjectURL(this.selectedReadFile);
    }
    this.selectedReadFile = "";
    this.documentViewerUrl = "";
    this.safeOfficeViewerUrl = null;
    this.documentViewerType = 'google';
  }

  playAudio(data: any) {
    const url = data['view_url'];
    const audiotag = this.document.createElement('audio');
    audiotag.src = url;
    audiotag.play();

  }

  getAudioUrl(index: any) {
    return this.chatfileAudioList[index]['view_url'];
  }

  showAudio(index: any) {
    this.showAudioIndex = index;
    let myBlob = this.chatfileAudioList[index]['view_url'];

    try {
      const url = this.chatfileAudioList[index]['view_url'];
      if (url) {

        this.securefileservice.secureReadfile(url).subscribe(
          (blob) => {
            let blobFile = new File([blob], 'myaudio.mp3', {
              type: 'audio/mp3',
            });
            let blobUrl = URL.createObjectURL(blobFile);
            this.audioSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
              blobUrl
            );
          },
          (error) => {

            console.log(error);
          }
        );
      }
    } catch (error) {

      console.log(error);
    }

  }

  hideAudio(audio_id: any) {
    const audio = document.querySelector("#" + audio_id) as HTMLAudioElement;
    // Stop = pause + reset the playhead
    audio.pause();
    audio.currentTime = 0;
    this.showAudioIndex = null;
    this.audioSafeUrl = '';
  }

  toggleDisclaimer() {
    this.showDisclaimer = !this.showDisclaimer;
  }

  closeTabPanel(event: any) {

    this.hideLeftContent = event['action'];
  }
  ngOnDestroy(): void {
    this.document.body.classList.remove('scroll-stop');

  }

  ShowTabpanel(panelName: any) {
    this.hideLeftContent = false;
    this.enableTabpanel = panelName;
  }

  changeQuery(event: any) {

    let modelType = event.target.value;
    if (modelType == "private") {
      this.assistBotService.queryType['library'] = true;
      this.toggle_text = "Ask anything....";
    } else {
      this.assistBotService.queryType['library'] = false;
      this.toggle_text = "How may i assist you";
    }

  }

  onRadioChange(event: any) {

  }

  scrollTop() {
    // this.document.getElementById("chat-list-content").scrollTop=0;
    $("#chat-list-content").animate({
      scrollTop: 0
    }, 'slow');
  }

  disabledVideoPlay() {
    this.activeTab = "";
    this.viewControl.hideDocumentView = !this.viewControl.hideDocumentView;
    this.getBotHistory();
    this.currentIndex = 0;
    //  if(this.viewControl.hideDocumentView){
    //   this.currentIndex =0;
    //    this.viewFile(this.currentIndex);
    //  }


  }

  getPreVideo() {
    this.currentIndex--;
    this.viewFile(this.currentIndex);
    this.nextDisabled = false;
    if (this.activeTab == 'history') {
      if (this.currentIndex === 0) {
        this.prevDisabled = true;
      }
    } else if (this.activeTab == 'pin') {
      if (this.currentIndex === 0) {
        this.prevDisabled = true;
      }
    } else if (this.activeTab == 'document') {
      if (this.currentIndex === 0) {
        this.prevDisabled = true;
      }
    } else if (this.activeTab == 'audio') {
      if (this.currentIndex === 0) {
        this.prevDisabled = true;
      }
    }


  }

  getNextVideo() {
    this.currentIndex++;
    this.viewFile(this.currentIndex);
    this.prevDisabled = false;
    if (this.activeTab == 'history') {
      if (this.currentIndex === 0 || (this.chatHistoryList.length - 1) == this.currentIndex) {
        this.nextDisabled = true;
      }
    } else if (this.activeTab == 'pin') {
      if (this.currentIndex === 0 || (this.chatPinList.length - 1) == this.currentIndex) {
        this.nextDisabled = true;
      }
    } else if (this.activeTab == 'document') {
      if (this.currentIndex === 0 || (this.chatfileList.length - 1) == this.currentIndex) {
        this.nextDisabled = true;
      }
    } else if (this.activeTab == 'audio') {
      if (this.currentIndex === 0 || (this.chatfileAudioList.length - 1) == this.currentIndex) {
        this.nextDisabled = true;
      }
    }
  }

  openDocumentpopup(tabName: any) {
    this.showPaginateSpinner = true;
    this.currentIndex = 0;
    this.search = "";
    if (tabName == "history") {
      this.getBotHistoryList();
    }
    else if (tabName == "pin") {
      this.PinOffset = 0;
      this.PinLimit = 25;
      this.currentIndex = 0;
      this.chatPinList = [];
      this.getBotPin();

    } else if (tabName == "audio") {
      this.AudioOffset = 0;
      this.AudioLimit = 25;
      this.currentIndex = 0;
      this.chatfileAudioList = [];
      this.getBotAudio();

    } else if (tabName == "document") {
      this.DocOffset = 0;
      this.DocLimit = 25;
      this.currentIndex = 0;
      this.chatfileList = [];
      this.getDocList();
    }

    /* this.assistBotService.getChatBotHistory().subscribe((result: any) => {
       if (result['success']) {

         let data = result['result'];
         console.log("bot data",data);
         this.assistBotService.chatHistoryList = data;
         this.assistBotService.chatPinList = data;
         this.chatHistoryList = this.assistBotService.chatHistoryList.filter((hList: any) => hList.question_type == "history" && hList.bot_type == "bot");
         this.chatPinList = this.assistBotService.chatPinList.filter((hList: any) => hList.question_type == "pin" && hList.bot_type == "bot");
         this.chatbotData = this.chatHistoryList;
         this.chatfileList = [];
         this.chatfileAudioList = [];
         this.chatfileList = this.assistBotService.chatHistoryList.filter((hList: any) => (hList.question_type == "pdf" || hList.question_type == "word") && hList.bot_type == "bot");
         this.chatfileAudioList = this.assistBotService.chatHistoryList.filter((hList: any) => hList.question_type == "audio" && hList.bot_type == "bot");

         this.viewFile(this.currentIndex);
       }else{
         this.showPaginateSpinner = false;
         if(result['result'].length==0){
           this.prevDisabled = true;
           this.nextDisabled = true;
         }
       }
     }); */
    this.activeTab = tabName;

    this.viewControl.hideDocumentView = true

    // setTimeout(() => {
    //   this.viewFile(this.currentIndex);
    // },2000);

  }

  changeNewLine(bot: any) {
    if (typeof bot === 'object' && bot !== null && bot.hasOwnProperty("bot_answer")) {
      return bot.bot_answer?.replace(/\n\r?/g, '<br />') || '';
    } else if (typeof bot === 'string') {
      return bot.replace(/\n\r?/g, '<br />');
    } else {
      return '';
    }
  }

  getllmUserInfo() {
    this.llmService.llmUserInfo().subscribe({
      next: (response: any) => {
        this.llmService.LLM_classes = response['class_access'];
        this.getElibrary().then((result: any) => {

          this.elibraryList = result;
        });
      },
      error: (error: HttpErrorResponse) => {

      }
    })
  }

  async getElibrary() {
    return new Promise((resolve, reject) => {
      const payLoad = {
        offset: 0,
        limit: 25,
        search: this.search || '',
        sort: 'time',
        data_type: true
      };

      this.staffRoomService.getClassList(payLoad).subscribe(
        (response: any) => {
          let temp_list = [];
          let elibraryList = [];
          if (response.hasOwnProperty('result')) {
            temp_list = response['result'];
            this.ClassListData = response['result'];
          } else {
            temp_list = response['chatList'];
            this.ClassListData = response['chatList'];
          }

          if (this.llmService.LLM_classes.length > 0) {

            this.llmService.LLM_classes.map(class_id => {
              temp_list.map(lib_list => {
                if (lib_list['group_id'] == class_id) {
                  elibraryList.push(lib_list);
                }
              });

            });
          }
          resolve(elibraryList);


        },
        (error) => {
          reject([]);
        });

    });
  }


  SelectClass(event: any) {
    if (this.assistBotService.queryType['library']) {
      this.toggle_text = "Ask anything....";
      if (event.target.value != "") {
        this.document.getElementById('classdropdown').parentElement.classList.remove("inactive");
        let index = Number(event.target.value);
        this.assistBotService.seletedClass = [];
        this.assistBotService.seletedClass.push(String(this.elibraryList[index]['group_id']));
        // this.toggle_text = "ask question from "+this.elibraryList[index]['full_name']+" documents";
      } else {
        this.assistBotService.seletedClass = [];
        // this.toggle_text="ask question from documents";
      }
    } else {
      this.toggle_text = "How may i assist you";
      this.assistBotService.seletedClass = [];
    }


  }

  dropdownSelectedClass(event: any) {

    this.assistBotService.seletedClass = [];
    this.assistBotService.seletedClass.push(String(event.value['group_id']));

    if (this.assistBotService.seletedClass > 0) {
      this.document.getElementById('classdropdown').parentElement.classList.remove("inactive");
    }

    // Sync values from service when class changes
    this.updateFromService();
    this.updateLLMBotPayload();


    //   if(this.selectedClassList.length > 0){

    //       this.selectedClassList.map((list=>{
    //      this.assistBotService.seletedClass.push(String(list['group_id']));
    //      className.push(list['full_name']);
    //    }));
    //   }

    //    if(this.assistBotService.seletedClass.length > 0){
    //      this.toggle_text = "ask question from "+className.join(", ")+" documents";
    //    }else{
    //     this.toggle_text = "ask question";
    //    }
  }

  fetchDataList(typeList: any) {
    if (typeList == 'history') {
      this.HistoryOffset = this.HistoryOffset + this.HistoryLimit;
      this.getBotHistory();
    } else if (typeList == 'pin') {
      this.PinOffset = this.PinOffset + this.PinLimit;
      this.getBotPin();
    } else if (typeList == 'document') {
      this.DocOffset = this.DocOffset + this.DocLimit;
      this.getDocList();
    } else if (typeList == 'audio') {
      this.AudioOffset = this.AudioOffset + this.AudioLimit;
      this.getBotAudio();
    }
  }



  getBotPin() {

    this.assistBotService.getBotPin(this.PinOffset, this.PinLimit).subscribe({
      next: (res: any) => {
        this.chatPinList = [...this.chatPinList, ...res['data']];
        // this.assistBotService.chatPinList = this.chatPinList;
        if (this.PinOffset == 0) {
          this.viewFile(this.currentIndex);
        }

        this.showPaginateSpinner = false;
      }, error: (error: HttpErrorResponse) => {
        this.showPaginateSpinner = false;
      }
    });
  }

  getBotAudio() {

    this.assistBotService.getBotAudio(this.AudioOffset, this.AudioLimit).subscribe({
      next: (res: any) => {
        this.chatfileAudioList = [...this.chatfileAudioList, ...res['data']];
        if (this.AudioOffset == 0) {
          this.viewFile(this.currentIndex);
        }

        this.showPaginateSpinner = false;
      },
      error: (error: HttpErrorResponse) => {
        this.showPaginateSpinner = false;
      }
    });
  }

  getDocList() {

    this.assistBotService.getBotDocument(this.DocOffset, this.DocLimit).subscribe({
      next: (res: any) => {
        this.chatfileList = [...this.chatfileList, ...res['data']];
        if (this.DocOffset == 0) {
          this.viewFile(this.currentIndex);
        }

        this.showPaginateSpinner = false;
      }, error: (error: HttpErrorResponse) => {
        this.showPaginateSpinner = false;
      }
    });
  }


  async fileValidationHanlder(files) {
    // Only validate file extensions, no size validation needed
    const rfpFileExt = ['PDF', 'DOC', 'DOCX', 'TXT', 'ODT'];
    const extensions = rfpFileExt.map((ext) => ext.toUpperCase().trim());

    for (let i = 0; i < files.length; i++) {
      const ext = files[i].name.toUpperCase().split('.').pop() || files[i].name;
      const exists = extensions.includes(ext);
      if (!exists) {
        this.alert.showAlertMessage({ message: `Error: ${files[i].name} - Unsupported file format. Only PDF, DOC, DOCX, TXT, ODT files are allowed.` });
        return false;
      }
    }
    return files;
  };
  async chooseUploadFile(event: any) {
    const files = event.target.files;

    // Check for allowed file types: PDF, DOC, DOCX, TXT, ODT
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
      "application/vnd.oasis.opendocument.text"
    ];

    const allowedExtensions = ['pdf', 'doc', 'docx', 'txt', 'odt'];
    const fileName = files[0].name.toLowerCase();
    const fileExtension = fileName.split('.').pop();

    const isAllowedType = allowedTypes.some(type => files[0].type.indexOf(type) !== -1) ||
      allowedExtensions.includes(fileExtension);

    if (isAllowedType) {
      this.fileLLMformData = new FormData();
      this.fileLLMformData.append('file', files[0], files[0].name);
    } else {
      this.alert.showAlertMessage({ "message": "Please upload only PDF, DOC, DOCX, TXT, or ODT files." });
      this.elibraryFileInput.nativeElement.value = null;
      return;
    }

    const fileValid = await this.fileValidationHanlder(files);
    if (fileValid) {
      this.concatFileIntoArray(files);
    }
  }

  removeUploadFile(data) {
    this.removeFileFromList(data);
    if (this.elibraryFileInput && this.elibraryFileInput.nativeElement) {
      this.elibraryFileInput.nativeElement.value = null;
    }
    this.fileLLMformData = null;
  }

  // Close modal and reset uploaded file
  closeUploadModal() {
    this.activeFileUpload = false;
    this.upLoadedFileList = [];
    this.fileLLMformData = null;
    this.isDragging = false;
    if (this.elibraryFileInput && this.elibraryFileInput.nativeElement) {
      this.elibraryFileInput.nativeElement.value = null;
    }
    // Reset form if needed
    if (this.uploadFileForm) {
      this.uploadFileForm.reset();
    }
  }

  // Drag and Drop handlers
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const fileInput = {
        target: {
          files: files
        }
      };
      this.chooseUploadFile(fileInput);
    }
  }

  // Helper method to get file icon class
  getFileIcon(mimeType: string): string {
    const iconMap: any = {
      'pdf': 'pi-file-pdf',
      'doc': 'pi-file-word',
      'docx': 'pi-file-word',
      'txt': 'pi-file',
      'odt': 'pi-file'
    };
    return iconMap[mimeType?.toLowerCase()] || 'pi-file';
  }

  // Helper method to format file size
  formatFileSize(bytes: number): string {
    if (!bytes || bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  }

  /** Remove files from selected list */
  removeFileFromList(val) {
    const data = val[0]
    if (this.upLoadedFileList.length > 0) {
      const newFileList = this.upLoadedFileList;
      const currentFiles = newFileList.filter(fl => fl.uniqId !== data.uniqId);
      const paramId = this.selectedClass;
      let fileEl = null;
      const existFileList = this.appComponent.selectedFilesList;
      fileEl = existFileList.find(el => el.group_id === paramId);
      if (fileEl) {
        fileEl.files = currentFiles;
      }
      this.upLoadedFileList = currentFiles;
      this.appComponent.selectedFilesList = existFileList;
    }
  }

  concatFileIntoArray(files) {
    if (files && files.length > 0) {

      if (this.upLoadedFileList.length < 1) {
        const fileObject = {
          user_id: null,
          group_id: null,
          files: []
        };
        const paramId = this.selectedClass;
        let fileEl = null;
        let existFileList = null;
        for (let i = 0; i < files.length; i++) {
          const splitArr = files[i].name.split('.');
          files[i].mimeType = splitArr[splitArr.length - 1].toLowerCase();
          files[i].uniqId = Date.now();
          existFileList = [...this.appComponent.selectedFilesList];
          fileEl = existFileList.find(el => el.group_id === paramId);
          if (fileEl) {
            fileEl.files.unshift(files[i]);
            this.upLoadedFileList = fileEl.files;

            if (files[i].mimeType === 'pdf' || files[i].mimeType === 'docx' || files[i].mimeType === 'doc' || files[i].mimeType === 'txt' || files[i].mimeType === 'odt') {
              // File type is valid
            }

          } else {
            fileObject.group_id = paramId;
            fileObject.files.push(files[i]);
            this.upLoadedFileList = fileObject.files;
            existFileList.unshift(fileObject);
          }
        }
        this.appComponent.selectedFilesList = existFileList;
      } else {
        this.alert.showAlertMessage({
          message: 'File seletion limit reached.'
        });
      }
    }


  }

  uploadLLM() {
    if (!this.fileLLMformData || !this.fileLLMformData.get("file")) {
      this.alert.showAlertMessage({ "message": "Please select a file to upload." });
      return;
    }

    this.showBtnSpinner = true;

    // Get client_id from user details
    let client_id = '';
    if (this.userDetail && this.userDetail['company_id']) {
      client_id = this.userDetail['company_id'];
    } else {
      // Fallback to localStorage if userDetail not available
      const userDetailStr = localStorage.getItem('userDetail');
      if (userDetailStr) {
        try {
          const userDetail = JSON.parse(userDetailStr);
          client_id = userDetail['company_id'] || '';
        } catch (e) {
          console.error('Error parsing userDetail from localStorage:', e);
        }
      }
    }

    if (!client_id) {
      // Try to get from headerService
      this.headerService.getCurrentUserDetail().subscribe((result: any) => {
        if (result['success'] && result['userDetail']) {
          client_id = result['userDetail']['company_id'] || '';
          this.performUpload(client_id);
        } else {
          this.showBtnSpinner = false;
          this.alert.showAlertMessage({ "message": "Unable to get client information. Please try again." });
        }
      });
    } else {
      this.performUpload(client_id);
    }
  }

  performUpload(client_id: string) {
    // Get doc_id array - using selectedDoc_ids from llmService
    const doc_id = this.llmService.selectedDoc_ids || [];

    // Append client_id and doc_id array to form data
    this.fileLLMformData.append('client_id', client_id);
    this.fileLLMformData.append('model_type',this.llmService.llm_bot_payload['model_type'] );
    // Append doc_id as JSON array string format [1,2]
    this.fileLLMformData.append('doc_id', JSON.stringify(doc_id));

    // Upload using llmService method following the same pattern as other API calls
    this.llmService.llmRfpQAUpload(this.fileLLMformData).subscribe({
      next: (response:any) => {
        this.showBtnSpinner = false;
        try {
          // Extract filename from Content-Disposition header if available
          let fileName = `rfp_qa_${new Date().getTime()}`; // Default filename
          const contentDisposition = response.headers.get('Content-Disposition');
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1].replace(/['"]/g, '');
              // Decode URI if needed
              try {
                fileName = decodeURIComponent(fileName);
              } catch (e) {
                // If decoding fails, use the original filename
              }
            }
          }

          // Download the file
          importedSaveAs(response.body, fileName);
          this.alert.showAlertMessage({ "message": "File downloaded successfully." });
          this.closeUploadModal();
        } catch (error) {
          console.error('Download error:', error);
          this.alert.showAlertMessage({ "message": "File downloaded but there was an error saving it." });
        }
      },
      error: (error: HttpErrorResponse) => {
        this.showBtnSpinner = false;
        console.error('Upload error:', error);
        // Try to extract error message from blob response if available
        if (error.error instanceof Blob) {
          error.error.text().then((text: string) => {
            try {
              const errorObj = JSON.parse(text);
              this.alert.showAlertMessage({ "message": errorObj.message || "Failed to upload file. Please try again." });
            } catch {
              this.alert.showAlertMessage({ "message": "Failed to upload file. Please try again." });
            }
          });
        } else {
          this.alert.showAlertMessage({ "message": error.error?.message || "Failed to upload file. Please try again." });
        }
      }
    });
  }
  newLessonCreate() {





    const formFields: any = {
      fieldName: null,
      activity: null,
      to_user_id: null,
      group_id: null,
      message: null,
    };





    let data = this.uploadFileForm.value;



    const userid = parseInt(window.localStorage.getItem('user_id'))

    const classList = this.groupUserList.filter(x => x !== userid)



    const existFileList = [...this.appComponent.selectedFilesList];
    let fileIndex = null;
    formFields.message = data.title;
    formFields.assessment = [];
    formFields.survey = [];
    formFields.polls = [];
    formFields.notes = [];
    formFields.is_download = true;
    formFields.price = 0;
    formFields.discount = 0;
    formFields.water_mark_title = "";
    formFields.description = "";
    formFields.duration = "";
    formFields.fieldName = 'group_gallery';
    formFields.activity = 'groupChatMessage';
    formFields.is_question_found = false;
    formFields.is_publish = false;
    formFields.is_survey_found = false;
    formFields.is_polls_found = false;
    formFields.is_notes_found = false;
    formFields.group_id = this.group_id;
    formFields.chat_user_list = classList;
    formFields.min_percentage = data.min_percentage;
    formFields.is_allow_retest = data.is_allow_retest ? data.is_allow_retest : false;
    formFields.random_question = 0;
    formFields["is_llm_training"] = this.llmfile_uuid ? true : false;

    formFields['summary'] = this.summarization;
    formFields['llmfile_uuid'] = this.llmfile_uuid ? this.llmfile_uuid : "";


    if (this.message_id) {
      formFields["message_id"] = this.message_id;
    }
    fileIndex = existFileList.findIndex(el => el.group_id === this.group_id);
    if (fileIndex >= 0) {
      existFileList.splice(fileIndex, 1);
    }

    this.appComponent.selectedFilesList = existFileList;

    //this.questionGenerateLoader = true;

    this.appComponent.fileUploadWithProgess(formFields, this.upLoadedFileList).then((fileList: any): void => {

      if (fileList[0]['llmfile_uuid']) {
        this.alert.showAlertMessage({ "message": "LLM Model Trained Successfully" });
        this.uploadFileForm.reset();
        this.activeFileUpload = false;
        this.showBtnSpinner = false;
      } else {
        this.uploadFileForm.reset();
      }
    }, (error: HttpErrorResponse) => {
      this.showBtnSpinner = false;

    });
  }

  getUserList() {

    const offset = 0;
    const payLoad = {
      offset: offset,
      limit: 25,
      search: '',
      groupId: this.uploadFileForm.value.group_id['group_id'],
      is_doc_section: true
    }

    this.chatService.getAttachmentsFileSearch(payLoad).subscribe(list => {

      this.groupUserList = list['groupUserDetail'];
    });

  }


  selectGroup(event) {
    console.log(event);
    this.group_id = event['value']['group_id'];
    this.getUserList();
  }

  ngAfterViewInit() {
    var activeRoleId = JSON.parse(window.localStorage.getItem('user_role'));
    // var roleId = activeRoleId.replace(/\"/g, "");
    this.userRole = parseInt(activeRoleId);


    /* if(this.appComponent.userDetail.is_tour_completed){
      setTimeout(()=>{

              //this.guidedTourService.startTour(TOUR);

            this.indexedDBService.getAllData().then(result=>{
                  console.log("table",result);
                });

                this.indexedDBService.getData(this.indexedDBService.userDetail['email_id']).then((res:any)=>{

                  if(res && res.hasOwnProperty('section')){
                    if(res['section'].length > 0){
                      let notComplete = res['section'].filter(data=>data['name']=='aiassist' && data['complete']==false);
                      if(notComplete.length > 0){
                        this.guidedTourService.startTour(TOUR);
                      }
                    }
                  }
                });
          },5000);
      } */



    let TOUR = {
      tourId: "aiassist-tour",
      useOrb: false,
      skipCallback: () => { this.updateUserOnboarding(); console.log("skip clicked") },
      completeCallback: () => { this.updateUserOnboarding(); console.log("complete clicked") },
      steps: [
        {
          title: "History",
          selector: "#history-list",
          content: "Click here to view all question and answer data.",
          orientation: Orientation.Left
        },
        {
          title: "Pin",
          selector: "#pin-list",
          content: "Click here to view all your pin data.",
          orientation: Orientation.Left
        },
        {
          title: "Audio",
          selector: "#audio-list",
          content: "Click here to view  all your generated audio files.",
          orientation: Orientation.Left
        },
        {
          title: "Document",
          selector: "#document-list",
          content: "Click here to view all your generated document files.",
          orientation: Orientation.Left
        }, {
          title: 'Private',
          selector: "#private-label",
          content: "If you choose private, you'll get answers from the trained documents",
          orientation: Orientation.Bottom
        }, {
          title: 'Generic',
          selector: "#generic-label",
          content: "If you choose generic, you'll get answers from the common public resources.",
          orientation: Orientation.Bottom
        }, {
          title: 'Documents',
          selector: "#classdropdown",
          content: "Select the document group from this list.",
          orientation: Orientation.Bottom
        }, {
          title: 'Question',
          selector: "#chat-message-enter-box",
          content: "Enter your question here.",
          orientation: Orientation.Bottom
        }, {
          title: 'Upload document',
          selector: "#upload-doc",
          content: "You can upload a document here to train the LLM. If you haven't created a document group yet, please follow these steps:<br><br> <b>Step 1:</b><br>Go to Manage Users and create a user.<br><b>Step 2:</b><br>Go to the Documents section, create a document group, then select that group to upload your document and train the LLM.",
          orientation: Orientation.Left
        }
      ]
    };

    if (this.userRole != 1) {
      TOUR['steps'].splice(8, 1);
    }

  }

  updateUserOnboarding() {
    this.indexedDBService.getData(this.indexedDBService.userDetail['email_id']).then((res: any) => {
      if (res) {
        if (res.hasOwnProperty('section')) {
          if (res['section'].length > 0) {
            let notComplete = res['section'].filter(data => data['name'] == 'aiassist' && data['complete'] == false);
            if (notComplete.length > 0) {
              notComplete[0]['complete'] = true;
              res['section'][0]['complete'] = true;
              let data = res['section'];
              this.indexedDBService.updateData(this.indexedDBService.userDetail['email_id'], data);
            }
          }
        }
      }
    });
  }

  navigateBack() {
    this.router.navigateByUrl("elibraryandcourse/e-library/" + this.llmService.llm_bot_payload['class_id']);
  }

  ngDestory() {
    this.chatbotData = [];
    this.chatHistoryList = [];
    this.chatfileList = [];
    this.chatfileAudioList = [];
    //  this.assistBotService.seletedClass=[];

  }

  showSelectedDocs() {
    // Update from service before showing
    this.updateFromService();

    const ids = this.llmService.selectedDoc_ids || [];
    if (!ids.length) {
      this.alert.showAlertMessage({ "message": "No documents selected" });
      return;
    }
    const names: string[] = ids.map((id: any) => this.llmService.selectedDoc_name_map?.[id] || id);
    const html = `<div style="max-height:300px;overflow:auto"><ul style="margin:0;padding-left:18px">${names.map(n => `<li>${n}</li>`).join('')}</ul></div>`;
    this.confirmDialogService.openConfirmDialog('', {
      title: 'Selected Documents (' + ids.length + ')',
      message: html,
      btnOkText: 'OK',
      btnCancelText: 'Close',
      onClose: () => { }
    });
  }

  updateFromService() {
    // Sync values from llmService
    this.selectedDoc_ids = this.llmService.selectedDoc_ids || [];
    this.selectedDoc_name_map = this.llmService.selectedDoc_name_map || {};
    this.selectedDoc_summary_category_map = this.llmService.selectedDoc_summary_category_map || {};

    // Populate CategoryList from selectedDoc_summary_category_map
    this.populateCategoryList();

  }

  populateCategoryList() {
    // Get unique categories from selectedDoc_summary_category_map
    const categorySet = new Set<string>();
    const categoryMap = new Map<string, any>();

    // Extract categories from llmService
    const categoryMapData = this.llmService.selectedDoc_summary_category_map || {};

    Object.keys(categoryMapData).forEach(docId => {
      const categoryValue = categoryMapData[docId];

      if (categoryValue) {
        try {
          // Try to parse if it's a JSON string
          let categories = categoryValue;
          if (typeof categoryValue === 'string') {
            try {
              categories = JSON.parse(categoryValue);
            } catch (e) {
              // If not JSON, treat as single category string
              categories = categoryValue;
            }
          }

          // Handle both array and single string cases
          if (Array.isArray(categories)) {

            console.log("categoriesValue", categories);
            categories.forEach((cat: any) => {
              if (cat.trim() != "[]") {
                const categoryName = typeof cat === 'string' ? cat : (cat?.name || cat?.category || String(cat));
                if (categoryName && !categorySet.has(categoryName)) {
                  categorySet.add(categoryName);
                  categoryMap.set(categoryName, {
                    full_name: categoryName,
                    category: categoryName,
                    value: categoryName
                  });
                }
              }
            });
          } else if (typeof categories === 'string' && categories.trim()) {

            console.log("categoriesValue", categories);
            if (categories.trim() != "[]") {
              const categoryName = categories.trim();
              if (!categorySet.has(categoryName)) {
                categorySet.add(categoryName);
                categoryMap.set(categoryName, {
                  full_name: categoryName,
                  category: categoryName,
                  value: categoryName
                });
              }
            }
          }
        } catch (error) {
          console.error('Error processing category:', error);
        }
      }
    });

    // Convert map to array
    this.CategoryList = Array.from(categoryMap.values());

  }

  dropdownSelectedCategory(event: any) {

    if (event.value) {
      // Filter selected documents by the selected category
      const selectedCategory = event.value.full_name || event.value.category || event.value.value;
      const filteredDocIds: any[] = [];

      // Get documents that match the selected category
      const categoryMapData = this.llmService.selectedDoc_summary_category_map || {};

      Object.keys(categoryMapData).forEach(docId => {
        const categoryValue = categoryMapData[docId];

        if (categoryValue) {
          try {
            let categories = categoryValue;
            if (typeof categoryValue === 'string') {
              try {
                categories = JSON.parse(categoryValue);
              } catch (e) {
                categories = categoryValue;
              }
            }

            let matches = false;
            if (Array.isArray(categories)) {
              matches = categories.some((cat: any) => {
                const categoryName = typeof cat === 'string' ? cat : (cat?.name || cat?.category || String(cat));
                return categoryName === selectedCategory;
              });
            } else if (typeof categories === 'string') {
              matches = categories.trim() === selectedCategory;
            }

            if (matches) {
              filteredDocIds.push(docId);
            }
          } catch (error) {
            console.error('Error filtering by category:', error);
          }
        }
      });


      // Update the llm_bot_payload with filtered document IDs if needed
      // You can add custom logic here based on your requirements
    } else {
      // If no category selected, use all selected documents
      this.updateLLMBotPayload();
    }
  }

  updateLLMBotPayload() {
    // Update llm_bot_payload with selected documents
    // Only update document_id if we have actual values to avoid overwriting with empty array
    if (this.selectedDoc_ids && this.selectedDoc_ids.length > 0) {
      this.llmService.llm_bot_payload['document_id'] = this.selectedDoc_ids;
    } else if (this.selectedDoc_ids === null || this.selectedDoc_ids === undefined) {
      // If selectedDoc_ids is null/undefined, don't update (keep existing value)
      console.log('selectedDoc_ids is null/undefined, keeping existing document_id');
    } else {
      // If it's an empty array, only update if we don't have an existing document_id
      if (!this.llmService.llm_bot_payload['document_id'] ||
        (Array.isArray(this.llmService.llm_bot_payload['document_id']) &&
          this.llmService.llm_bot_payload['document_id'].length === 0)) {
        this.llmService.llm_bot_payload['document_id'] = [];
      }
    }

    // If you need to pass summary_category in the payload, you can add it here
    // this.llmService.llm_bot_payload['summary_category'] = this.selectedDoc_summary_category_map;

    // Save to localStorage to persist across page refreshes
    this.llmService.saveLLMBotPayload();

  }

  startLiveSpeakAssist() {
    this.router.navigate(['/live-speak-assist']);
  }



}








